export default __webpack_public_path__ + "assets/mailIcon.a5480275.png";